var _path, _rect, _circle, _circle2, _circle3, _circle4, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApiCenterActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4456 0C9.83199 0 9.33453 0.497462 9.33453 1.11111C9.33453 1.72488 8.83697 2.22244 8.2232 2.22244H4.66753C3.56297 2.22244 2.66753 3.11787 2.66753 4.22244V7.77799C2.66753 8.39164 2.17007 8.88911 1.55642 8.88911C0.942774 8.88911 0.445312 9.38657 0.445312 10.0002C0.445312 10.6139 0.942774 11.1113 1.55642 11.1113C2.17007 11.1113 2.66753 11.6088 2.66753 12.2224V13.3335C2.66753 13.9472 2.17007 14.4447 1.55642 14.4447C0.942774 14.4447 0.445312 14.9421 0.445312 15.5558C0.445312 16.1694 0.942774 16.6669 1.55642 16.6669C2.17007 16.6669 2.66753 17.1643 2.66753 17.778V18.8891C2.66753 19.5028 2.17007 20.0002 1.55642 20.0002C0.942774 20.0002 0.445312 20.4977 0.445312 21.1113C0.445312 21.725 0.942774 22.2224 1.55642 22.2224C2.17007 22.2224 2.66753 22.7199 2.66753 23.3335V26.8891C2.66753 27.9937 3.56296 28.8891 4.66753 28.8891H27.3342C28.4388 28.8891 29.3342 27.9937 29.3342 26.8891V23.3335C29.3342 22.7199 29.8317 22.2224 30.4453 22.2224C31.059 22.2224 31.5564 21.725 31.5564 21.1113C31.5564 20.4977 31.059 20.0002 30.4453 20.0002C29.8317 20.0002 29.3342 19.5028 29.3342 18.8891V17.778C29.3342 17.1643 29.8317 16.6669 30.4453 16.6669C31.059 16.6669 31.5564 16.1694 31.5564 15.5558C31.5564 14.9421 31.059 14.4447 30.4453 14.4447C29.8317 14.4447 29.3342 13.9472 29.3342 13.3336V12.2224C29.3342 11.6088 29.8317 11.1113 30.4453 11.1113C31.059 11.1113 31.5564 10.6139 31.5564 10.0002C31.5564 9.38657 31.059 8.88911 30.4453 8.88911C29.8317 8.88911 29.3342 8.39165 29.3342 7.778V4.22244C29.3342 3.11787 28.4388 2.22244 27.3342 2.22244H23.7792C23.1654 2.22244 22.6679 1.72488 22.6679 1.11111C22.6679 0.497461 22.1704 0 21.5567 0C20.9431 0 20.4456 0.497462 20.4456 1.11111C20.4456 1.72488 19.9481 2.22244 19.3343 2.22244H18.2236C17.6099 2.22244 17.1123 1.72488 17.1123 1.11111C17.1123 0.497461 16.6148 0 16.0012 0C15.3875 0 14.8901 0.497462 14.8901 1.11111C14.8901 1.72488 14.3925 2.22244 13.7788 2.22244H12.6681C12.0543 2.22244 11.5567 1.72488 11.5567 1.11111C11.5567 0.497461 11.0593 0 10.4456 0Z",
    fill: "url(#paint0_linear_524_22840)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.89062,
    y: 4.44482,
    width: 22.2222,
    height: 22.2222,
    fill: "url(#paint1_linear_524_22840)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.11111,
    cy: 6.66726,
    r: 1.11111,
    fill: "#78CFB5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.8904,
    cy: 6.66726,
    r: 1.11111,
    fill: "#78CFB5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.11111,
    cy: 24.4451,
    r: 1.11111,
    fill: "#78CFB5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.8904,
    cy: 24.4451,
    r: 1.11111,
    fill: "#78CFB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.998 16.4812L11.238 15.6892C11.43 15.0492 11.614 14.4012 11.782 13.7292H11.814C11.998 14.3932 12.174 15.0492 12.374 15.6892L12.606 16.4812H10.998ZM13.326 18.8892H14.31L12.358 13.0012H11.286L9.33398 18.8892H10.278L10.782 17.2092H12.83L13.326 18.8892ZM15.0865 18.8892H16.0145V16.6572H16.9025C18.1825 16.6572 19.1185 16.0652 19.1185 14.7772C19.1185 13.4492 18.1825 13.0012 16.8705 13.0012H15.0865V18.8892ZM16.0145 15.9132V13.7452H16.7825C17.7185 13.7452 18.2065 14.0012 18.2065 14.7772C18.2065 15.5532 17.7585 15.9132 16.8145 15.9132H16.0145ZM20.2662 18.8892H21.1942V13.0012H20.2662V18.8892Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_524_22840",
    x1: 16.0009,
    y1: 0,
    x2: 16.0009,
    y2: 28.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74CDB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9AE4D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_524_22840",
    x1: 7.11285,
    y1: 10.2419,
    x2: 23.1872,
    y2: 26.4868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3EEDB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiCenterActive);
export default "https://cdn.d2cgo.com/dtc_center/v19/content_assets/static/media/apiCenter_active.0185d78e0633974ed2257561c1a020e4.svg";
export { ForwardRef as ReactComponent };